<mat-tab-group (click)="onTabClick($event)" [selectedIndex]="getSelectedTabIndex()" class="tab-group-content">
  <mat-tab label="CADASTRAR BENEFICIÁRIO" disabled class="tab-group-content">
    <div class="search-box">
      <select [formControl]="searchType">
        <option value="1">BUSCA POR CNPJ</option>
        <option value="2">BUSCA POR RAZÃO SOCIAL</option>
      </select>
      <input
        #inputValue
        *ngIf="searchType.value == 1"
        [(ngModel)]="filterText"
        placeholder="01.234.567/0001-00"
        [textMask]="{
          mask: fiscalNumberMask,
          guide: false,
          keepCharPositions: true
        }"
        (keypress)="onPressEnterSearchCompanies($event)" />
      <input #inputValue *ngIf="searchType.value == 2" [(ngModel)]="filterText" placeholder="Razão Social" (keypress)="onPressEnterSearchCompanies($event)" />
      <div class="search-icon-container" (click)="searchCompanies(filterText)">
        <mat-icon aria-hidden="false">search</mat-icon>
      </div>
    </div>

    <div class="company-card" *ngIf="hasCompany()">
      <div class="company-logo">
        <img src="./assets/icons/no-logo-company-icon.svg" />
      </div>

      <div class="company-data">
        <span class="company-name">{{ getCompany().getCorporateName() }} </span>
        <span class="company-cnpj">
          CNPJ:
          {{ getCompany().getFiscalNumber() | companyFederalNumber }} </span
        ><span class="company-lives"> Vidas: {{ getCompany().getCompanyInfo().getEmployeeCount() }} </span>
      </div>

      <div class="card-number-container row-1" *ngIf="hasBeneficiaryKey()">
        <span><b>Número do Cartão: </b>{{ cardNumber() | cardNumberFormat }}</span>
      </div>
    </div>

    <diV *ngIf="!hasCompany()" class="company-card-container">
      <div class="search-control">
        <p *ngIf="companyPageableResult.getItems().length > 1">{{ companyPageableResult.getItems().length }} RESULTADOS ENCONTRADOS</p>
        <p *ngIf="companyPageableResult.getItems().length === 1">1 RESULTADO ENCONTRADO</p>
        <div class="scroll-text" *ngIf="showScrollBottomBtn()" (click)="scrollToLastCompany()">
          <mat-icon aria-hidden="false">arrow_drop_down</mat-icon>
          <span class="btn-title">ir para o fim da lista</span>
        </div>
      </div>

      <div *ngFor="let company of companyPageableResult.getItems()">
        <div class="company-card">
          <div class="company-logo">
            <img src="./assets/icons/no-logo-company-icon.svg" />
          </div>
          <div class="company-data">
            <p class="company-name">{{ company.getCorporateName() }}</p>
            <p class="company-cnpj">CNPJ: {{ company.getFiscalNumber() | companyFederalNumber }}</p>
            <p class="company-description">{{ company.getTradingName() }}</p>
          </div>
          <div class="company-status">
            <div class="status"><mat-icon aria-hidden="false">check_circle_outline</mat-icon>ATIVA</div>
            <div class="edit-btn" (click)="searchCompany(company)"><mat-icon aria-hidden="false">add_box</mat-icon> ADICIONAR</div>
          </div>
        </div>
      </div>

      <a class="more-companies-btn" *ngIf="showMoreCompaniesBtn()" (click)="searchMoreCompanies()">carregar mais registros</a>
      <div id="bottom"></div>
    </diV>

    <div [formGroup]="registrationBeneficiaryForm" class="registration-beneficiary-container" *ngIf="hasCompany()">
      <div class="form-content" fxFlex fxLayout="column">
        <div fxFlex="100">
          <mat-checkbox
            #enableDelivery
            fxFlex
            formControlName="enableDelivery"
            labelPosition="after"
            matTooltip="Ao marcar esta opção, habilitara o Delivery no app Healthy IP.">
            Habilitar delivery
          </mat-checkbox>
        </div>
        <div fxFlex="100">
          <mat-form-field fxFlex>
            <mat-label>CPF</mat-label>
            <input
              matInput
              formControlName="socialNumber"
              type="search"
              (change)="onBeneficiaryInputChange()"
              (keyup)="searchBeneficiary()"
              [textMask]="{
                mask: socialNumberMask,
                guide: false,
                keepCharPositions: true
              }"
              [readonly]="hasBeneficiaryKey()"
              required />
            <mat-icon matSuffix class="visibility-icon" (click)="openVinculatedDialog()">info</mat-icon>
          </mat-form-field>
          <mat-form-field fxFlex="60">
            <mat-label>Nome</mat-label>
            <input matInput formControlName="name" type="text" (change)="onBeneficiaryInputChange()" required />
          </mat-form-field>
        </div>
        <div fxFlex="100">
          <mat-form-field fxFlex="25">
            <mat-label>Data de Admissão</mat-label>
            <input
              matInput
              formControlName="admissionDate"
              type="text"
              (change)="onBeneficiaryInputChange()"
              [textMask]="{
                mask: dateMask,
                guide: false,
                keepCharPositions: true
              }" />
          </mat-form-field>

          <mat-form-field fxFlex="20">
            <mat-label>Matrícula</mat-label>
            <input matInput formControlName="registration" type="text" (change)="onBeneficiaryInputChange()" />
          </mat-form-field>

          <mat-form-field fxFlex>
            <mat-label>Cargo</mat-label>
            <mat-select formControlName="jobDescription">
              <mat-option *ngFor="let job of getJobList()" [value]="job">{{ job.getTitle() }}</mat-option>
              <mat-option (click)="openAddJobDescriptionDialog()">- Adicionar novo cargo -</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div fxFlex="100">
          <mat-form-field fxFlex>
            <mat-label>Data de Nascimento</mat-label>
            <input
              matInput
              formControlName="birthDate"
              type="text"
              (change)="onBeneficiaryInputChange()"
              [textMask]="{
                mask: dateMask,
                guide: false,
                keepCharPositions: true
              }" />
          </mat-form-field>

          <mat-form-field fxFlex>
            <mat-label>Sexo</mat-label>
            <mat-select formControlName="gender" (selectionChange)="onBeneficiaryInputChange()" required>
              <mat-option [value]="0">{{ genderType.Male }}</mat-option>
              <mat-option [value]="1">{{ genderType.Female }}</mat-option>
              <mat-option [value]="2">{{ genderType.Unknow }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field fxFlex>
            <mat-label>Estado Civil</mat-label>
            <mat-select formControlName="maritalStatus" (selectionChange)="onBeneficiaryInputChange()" required>
              <mat-option [value]="0">Casado</mat-option>
              <mat-option [value]="1">Solteiro</mat-option>
              <mat-option [value]="2">Divorciado</mat-option>
              <mat-option [value]="3">Viúvo</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div fxFlex="100">
          <mat-form-field fxFlex>
            <mat-label>Telefone</mat-label>
            <input
              matInput
              formControlName="telephone"
              type="text"
              (change)="onBeneficiaryInputChange()"
              [textMask]="{
                mask: telephoneMask,
                guide: false,
                keepCharPositions: true
              }" />
          </mat-form-field>

          <mat-form-field fxFlex>
            <mat-label>Celular</mat-label>
            <input
              matInput
              formControlName="mobile"
              type="text"
              (change)="onBeneficiaryInputChange()"
              [textMask]="{
                mask: mobileMask,
                guide: false,
                keepCharPositions: true
              }" />
          </mat-form-field>
        </div>
        <div fxFlex="100">
          <mat-form-field fxFlex="20">
            <mat-label>CEP</mat-label>
            <input
              matInput
              formControlName="zipCode"
              type="text"
              (change)="onBeneficiaryInputChange()"
              (keyup)="getZipCode()"
              [textMask]="{
                mask: zipCodeMask,
                guide: false,
                keepCharPositions: true
              }" />
          </mat-form-field>

          <mat-form-field fxFlex>
            <mat-label>Endereço</mat-label>
            <input matInput formControlName="street" type="text" (change)="onBeneficiaryInputChange()" />
          </mat-form-field>

          <mat-form-field fxFlex="15">
            <mat-label>Número</mat-label>
            <input matInput formControlName="number" type="text" (change)="onBeneficiaryInputChange()" />
          </mat-form-field>
        </div>
        <div fxFlex="100">
          <mat-form-field fxFlex="25">
            <mat-label>Complemento</mat-label>
            <input matInput formControlName="complement" type="text" (change)="onBeneficiaryInputChange()" />
          </mat-form-field>

          <mat-form-field fxFlex="15">
            <mat-label>Estado</mat-label>
            <mat-select formControlName="region" (selectionChange)="onStateInputChange()" [(ngModel)]="region" required>
              <mat-option [value]="0">Selecione</mat-option>
              <mat-option *ngFor="let state of getStateList()" [value]="state">{{ state.getValue() }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field fxFlex>
            <mat-label>Cidade</mat-label>
            <mat-select formControlName="city" (selectionChange)="onBeneficiaryInputChange()" [(ngModel)]="city" required>
              <mat-option [value]="0">Selecione</mat-option>
              <mat-option *ngFor="let city of getCityList()" [value]="city">{{ city.getName() }}</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field fxFlex>
            <mat-label>Bairro</mat-label>
            <input matInput formControlName="district" type="text" (change)="onBeneficiaryInputChange()" required />
          </mat-form-field>
        </div>
        <div fxFlex="100">
          <mat-form-field fxFlex="70">
            <mat-label>E-mail</mat-label>
            <input matInput formControlName="email" type="text" (change)="onBeneficiaryInputChange()" [required]="needValidateEmail.checked" />
          </mat-form-field>

          <mat-checkbox
            #needValidateEmail
            fxFlex="30"
            formControlName="needValidateEmail"
            labelPosition="after"
            matTooltip="Ao marcar esta opção, o beneficiário deverá utilizar o mesmo email informado aqui quando for acessar o aplicativo.">
            Validar email no primeiro acesso
          </mat-checkbox>
        </div>
        <div  fxLayoutAlign="start center">
              <mat-checkbox formControlName="transactionPasswordRequired" fxLayoutAlign="center center"
              labelPosition="after"
              matTooltip="Requer senha para efetuar transações">
              Permitir segurança transacional?
            </mat-checkbox>
          </div>
      </div>
    </div>
    <div class="actions-container" *ngIf="hasCompany()">
      <button mat-flat-button *ngIf="hasBenficiary() && !isBeneficiaryCardBlocked()" class="block-card-btn" (click)="openCardBlockDialog()">
        BLOQUEAR CARTÃO
      </button>

      <button mat-flat-button class="registrate-beneficiary-btn" (click)="saveBenficiary()">SALVAR BENEFICIÁRIO</button>
    </div>
  </mat-tab>

  <mat-tab label="Lista de Dependentes" *ngIf="hasBenficiary()" enabled>
    <div class="dependent-list-header">
      <span>Dependentes Cadastrados: {{ getDependents().length }}</span>

      <div class="registrate-dependent-btn" (click)="gotToCreateDependent()">
        <span>REGISTRAR DEPENDENTE</span>
      </div>
    </div>

    <div class="dependent-list-container">
      <div class="beneficiary-card" style="margin-top: 2vh" *ngFor="let dependent of getDependents()">
        <div class="benecifiary-data">
          <div class="data-container">
            <div class="row-1">
              <p>{{ dependent?.getName() }}</p>
            </div>

            <div class="row-2">
              <span><b>Número do cartão: </b>{{ dependent?.getCard()?.getCardNumber() | cardNumberFormat }}</span>
            </div>

            <div class="row-3">
              <div class="data-column">
                <span><b>CPF: </b> {{ dependent?.getSocialNumber() | socialNumberFormatPipe }}</span>
                <span><b>Nascimento: </b> {{ dependent?.getBirthDate() | dateFormat }}</span>
              </div>

              <div class="data-column">
                <span><b>Sexo: </b> {{ dependent?.getGender()?.getView() }}</span>
                <span><b>Estado Civil: </b> {{ dependent?.getMaritalStatus()?.getView() }}</span>
              </div>

              <div class="data-column">
                <span><b>Celular: </b> {{ dependent?.getMobile() | mobileFormatPipe }}</span>
                <span><b>E-mail: </b> {{ dependent?.getEmail() }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="btn-container">
          <div class="btn" style="background-color: #f2950a" (click)="goToEditDependent(dependent)">
            <img class="btn-img" src="./assets/icons/edit-icon.svg" />
            <span class="btn-title">EDITAR</span>
          </div>

          <div
            class="btn"
            [ngStyle]="{
              'background-color': dependent.isActive() ? '#2DCD7A' : 'darkgray'
            }">
            <img *ngIf="dependent.isActive()" class="btn-img" style="width: 1.1vw" src="./assets/icons/check-circle-icon.svg" />
            <img *ngIf="!dependent.isActive()" class="btn-img" style="width: 0.6vw" src="./assets/icons/delete-icon.svg" />
            <span class="btn-title">{{ dependent.isActive() ? "ATIVO" : "INATIVO" }}</span>
          </div>
        </div>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>
